// extracted by mini-css-extract-plugin
module.exports = {"root":"AboutTheAuthors_root__COLKE","content":"AboutTheAuthors_content__1gwUS","label":"AboutTheAuthors_label__iQq4F"};